import React, { useMemo, useState,useEffect } from "react";
import { PaymentStatus } from "../../Dashboard/LatestTranactionCol";
import { Link } from "react-router-dom";
import { Col, Container, Row, UncontrolledTooltip } from "reactstrap";
import EcommerceOrdersModal from "../../Ecommerce/EcommerceOrders/EcommerceOrdersModal";
import EcommerceOrdersPaymentModal from "../../Ecommerce/EcommerceOrders/EcommerceOrdersPaymentModal";
import EcommerceOrdersTrackingModal from "../../Ecommerce/EcommerceOrders/EcommerceOrdersTrackingModal";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import TableContainer from "../../../components/Common/TableContainer";

const CorporateOrder = () => {

  const baseurl = process.env.REACT_APP_BASE_URL;
    const imgurl = process.env.REACT_APP_IMAGE_URL;
  
    const [customerOrderData, setcustomerOrderData] = useState([]);
    const [error, setError] = useState(null);

  const [orderDetailsModel, setOrderDetailsModal] = useState(false);
  const [paymentDetailsModel, setPaymentDetailsModal] = useState(false);
  const [trackingDetailsModel, setTrackingDetailsModal] = useState(false);
  const toggleViewModal = () => setOrderDetailsModal(!orderDetailsModel);
  const togglePaymentDetailsViewModal = () =>
    setPaymentDetailsModal(!paymentDetailsModel);
  const toggleTrackingDetailsViewModal = () =>
    setTrackingDetailsModal(!trackingDetailsModel);

  const fetchindividualCustomerOrder = async () => {
                try {
                  setError(null);
                  const response = await fetch(`${baseurl}/admin/customer/corporate-orders`);
                  if (!response.ok) throw new Error("Network response was not ok");
                  const data = await response.json();
                  setcustomerOrderData(data);
                } catch (error) {
                  setError(error.message);
                }
              };
    
              useEffect(() => {
                          fetchindividualCustomerOrder();
                        }, []);

  const columns = useMemo(
    () => [
      {
        Header: "Order ID",
        accessor: "order_id",
        filterable: true,
      },
      {
        Header: "Customer Name",
        accessor: "user_name",
        filterable: true,
      },
      {
        Header: "Date",
        accessor: "created_at",
        filterable: true,
      },
      {
        Header: "Total",
        accessor: "total_amount",
        filterable: true,
      },
      {
         Header: "Order Status",
        accessor: "order_status",
        filterable: true,
        Cell: (cellProps) => {
          return <PaymentStatus {...cellProps} />;
        },
      },
      
      {
        Header: "View Details",
        disableFilters: true,
        accessor: "view",
        Cell: (cellProps) => {
          const orderId = cellProps.row.original.order_id;
          return (
            <div className="d-flex gap-3 align-items-center">
              <Link
                to={`/manage-orders/corporate-customer/order-details/${orderId}`}
                className="text-success"
              >
                <i
                  className="mdi mdi-eye-outline font-size-18"
                  id="viewtooltip"
                ></i>
                <UncontrolledTooltip placement="top" target="viewtooltip">
                  View
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-success"
                onClick={togglePaymentDetailsViewModal}
              >
                <i
                  className="fab fas fa-money-bill-alt font-size-14"
                  id="paymentbutton"
                />
                <UncontrolledTooltip placement="top" target="paymentbutton">
                  Payment Details
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-success"
                onClick={toggleTrackingDetailsViewModal}
              >
                <i className="bx bxs-truck font-size-18" id="trackingbutton" />
                <UncontrolledTooltip placement="top" target="trackingbutton">
                  Tracking Details
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );

  document.title = "Corporate Customer Orders | Vekart";
  return (
    <>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Orders" breadcrumbItem="Corporate Customer Orders" />
          <EcommerceOrdersModal
            isOpen={orderDetailsModel}
            toggle={toggleViewModal}
          />
          <EcommerceOrdersPaymentModal
            isOpen={paymentDetailsModel}
            toggle={togglePaymentDetailsViewModal}
          />
          <EcommerceOrdersTrackingModal
            isOpen={trackingDetailsModel}
            toggle={toggleTrackingDetailsViewModal}
          />
          <Row>
            <Col lg="12">
              <TableContainer
                columns={columns}
                data={customerOrderData}
                isGlobalFilter={true}
                customPageSize={10}
                className="custom-header-css"
              />
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default CorporateOrder;
